export const validateEmail = (emailaddress: string) => {
  const r = String.raw;
  const emailAddressPattern = new RegExp(
    // beginning of string
    r`^` +
      // username portion: one or more characters that are not whitespace or @
      r`[^@\s]+` +
      // an @ symbol
      r`@` +
      // domain components: one or more groups of one or more characters
      // other than @, \, ., or whitespace, each followed by a . separator
      r`(?:[^@\s\\.]+\.)+` +
      // TLD: one additional domain component but without a . after it
      r`[^@\s\\.]+` +
      // end of string
      r`$`,
  );

  return emailAddressPattern.test(emailaddress);
};

interface Params {
  emailAddress: string;
  validationsToRun?: typeof validateEmail;
}

export const valid = ({
  emailAddress,
  validationsToRun = validateEmail,
}: Params) => validationsToRun(emailAddress);
